<template>
  <div class="detail-wrap">
    <el-form ref="editForm" :model="tenant">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info"/>
          {{ dataId ? '查看' : '新增' }}回访设置
        </div>
        <div class="fr">
<!--          <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-refresh-right">重置-->
<!--          </el-button>-->
          <el-button type="primary" class="button-sty" icon="el-icon-check"
                     v-if="(recallProjectEdit && tenant.id != null) || (recallProjectAdd && tenant.id == null)"
                     @click="saveData">保存</el-button>
        </div>
      </div>
      <div>

        <!-- 品牌信息 -->
        <div class="d-cont edit-mce-box">
          <div class="d-item">
            <div class="title first">
              <b>主信息</b>
            </div>
            <table class="table-detail">
              <tbody>
              <tr>
                <!--                  <th>-->
                <!--                    <em class="f-red">*</em>-->
                <!--                    厂商ID-->
                <!--                  </th>-->
                <!--                  <td>-->
                <!--                    <el-input type="text" autocomplete="off" v-model="tenant.companyId" clearable />-->
                <!--                  </td>-->
                <th>
                  <em class="f-red">*</em>
                  编码
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="tenant.projectCode" clearable/>
                </td>
                <th>
                  <em class="f-red">*</em>
                  名称
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="tenant.projectName" clearable/>
                </td>
                <th>
                  <em class="f-red">*</em>
                  值类型
                </th>
                <td>
                  <el-select v-model="tenant.valueType">
                    <el-option label="选项值" :value="1"/>
                    <el-option label="文本" :value="2"/>
                  </el-select>
                </td>
                <th>
                  选项值
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="tenant.valueSplit" clearable/>
<!--                  <el-select v-model="tenant.valueSplit">-->
<!--                    <el-option label="审单" :value="1"/>-->
<!--                    <el-option label="回访" :value="2"/>-->
<!--                  </el-select>-->
                </td>
              </tr>
              <tr>
                <th>
                  <em class="f-red">*</em>
                  排序
                </th>
                <td>
                  <el-input-number min="0" max="10" style="width:165px" :controls="false" v-model="tenant.seq"/>
                </td>
                <th>
                  <em class="f-red">*</em>
                  启用
                </th>
                <td>
                  <el-select v-model="tenant.usable">
                    <el-option label="禁用" :value=0></el-option>
                    <el-option label="启用" :value=1></el-option>
                  </el-select>
                </td>
              </tr>
              <tr>
                <th>创建人</th>
                <td>{{ tenant.createBy }}</td>
                <th>创建时间</th>
                <td>{{ tenant.createTime }}</td>
              </tr>
              </tbody>
            </table>
          </div>

        </div>

      </div>
    </el-form>
    <productCategoryDialog v-if="showProductCategoryDialog" :visiable.sync="showProductCategoryDialog" multi="false"
                           @confirm="confirmCategory"/>
  </div>
</template>
<script>
import {
  initVxeTable
} from '@/const/crud/admin/table';
import Tinymce from '@/components/Tinymce';
import request from "@/router/axios";
import {mapGetters} from "vuex";
import {editPageMixins} from "@/mixins/tabChang";

export default {
  mixins: [editPageMixins],
  name: 'edit',
  props: {
    _dataId: [String, Number]
  },
  components: {
    Tinymce,
  },
  data() {
    return {
      recallProjectAdd: false,
      recallProjectEdit: false,
      img_b: "",
      upload_btn: false, // 是否隐藏上传图片按钮
      radio: '1',
      showEdit: false,
      valuetype: 'model',
      textarea: '',
      //  value1: true,
      value2: false,
      value3: true,
      activeName: 'first',
      dialog: {
        one: false,
      },
      lan: 'zh_CN',
      isEdit: false,
      tabIndex: 'first',
      dataId: '',
      intValueSplit: '',
      // 基本信息
      service: {
        pic: '',
      },
      tenant: {
        id: null,
        status: 0,
        tenantAttachmentDTOs: [],
        projectCode: '',
        projectName: '',
        valueType: 1,
        valueSplit: '',
        usable: 1,
        seq: 0
      },
      showProductCategoryDialog: false,
    };
  },
  computed: {
    ...mapGetters(["permissions"])
  },
  created() {
    this.recallProjectEdit = this.permissions['recall_project_edit']
    this.recallProjectAdd = this.permissions['recall_project_add']

    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
    // console.log(this.tenant,"tenant的值");
  },
  mounted() {

    this.getData();
    console.log(this.tenant, "tenant的值");
    console.log(this._dataId, "_dataId的值");
  },
  methods: {
    confirmSaleConfig(rows) {
      if (rows.length > 0) {
        const $grid = this.$refs.configGrid;
        const tableData3 = $grid.getTableData().fullData;
        const map = {};
        tableData.forEach(function (item) {
          map[item.configId] = 1;
        });
        var items = [];
        rows.forEach((row, index) => {
          const item = {
            configId: row.id,
            configName: row.configName
          };
          if (index == 0 && tableData3.length == 0) {
            item.defaults = true;
          }
          if (!map[item.configId]) {
            items.push(item);
          }
        });
        this.product.saleProductConfigDTOs = this.product.saleProductConfigDTOs.concat(items);
      }
    },
    // 上传成功

    // 第一个  表格
    formatter(row, column) {
      return row.address;
    },
    submitUpload() {
      this.$refs.upload.submit()
    },

    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        request({
          url: '/basic/basRecallProject/get',
          method: 'post',
          data: {
            id: this.dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          this.tenant = response.data.data;
          // this.intValueSplit = response.data.data.valueSplit;
          // this.tenant.valueSplit = this.intValueSplit - 0;
        })
      } else {
        // this.enabled = true;
      }
    },
    saveData() {
      this.$refs.editForm.validate(valid => {
        if (this.tenant.valueType == 1 && !this.tenant.valueSplit) {
          this.$message.error('选项值不能为空')
          return
        }

        if (valid) {
          this.$baseConfirm('您确定要保存吗？').then(() => {
            this.$mask.open()

            var url = (this.isEdit ? `/basic/basRecallProject/update` : `/basic/basRecallProject/save`);
            this.$http({
              url: url,
              method: `post`,
              data: this.tenant,
              isLoading: true,
            }).then(res => {
              this.$message.success("保存成功！")
              this.goBackIndex()
              this.$mask.close()


              // this.$emit('editViewDataUpdate')
            }).catch(e => {
              console.error(e)
              this.$message.error("保存失败！")
              this.$mask.close()

            });
          });
        }
      });
    },
    confirmCategory(rows) {
      if (rows.length > 0) {
        let row = rows[0];
        this.tenant.itemCatId = row.id;
        this.tenant.itemCatName = row.categoryName;
        this.tenant.itemCatCode = row.categoryCode;
      }
    },
  },
};

</script>
<style lang="scss" scoped>
</style>
